import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import '../pages/css/ContactUs.css';
import Swal from 'sweetalert2';
import banner from '../images/Hrias-contact-banner.png';
import { motion, AnimatePresence } from "framer-motion";

function ContactUsHrias() {

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        whatsapp: '',
        city: '',
        company: '',
        website: '',
        industry: '',
        softwareType: '',
        budget: '',
        timeline: '',
        extra: ''
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handlePhoneChange = (value) => {
        setFormData({ ...formData, phone: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Manual validation for required fields
        if (
            !formData.fullName.trim() ||
            !formData.email.trim() ||
            !formData.phone.trim() ||
            !formData.city.trim() ||
            !formData.company.trim()
        ) {
            Swal.fire({
                title: 'Missing Required Fields',
                text: 'Please fill all mandatory fields before submitting.',
                icon: 'warning',
                confirmButtonColor: '#3085d6'
            });
            return; // Stop form submission
        }

        setLoading(true);

        try {
            const res = await fetch("https://peregrinee.com/hriasMailServer/sendMail.php", {
            // const res = await fetch("http://localhost:5000/sendMail.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const result = await res.json();

            if (result.status === "success") {
                Swal.fire({
                    title: 'Success!',
                    text: 'Your form has been submitted successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#3085d6'
                });
                setFormData({
                    fullName: '',
                    email: '',
                    phone: '',
                    whatsapp: '',
                    city: '',
                    company: '',
                    website: '',
                    industry: '',
                    softwareType: '',
                    budget: '',
                    timeline: '',
                    extra: ''
                });
            } else {
                alert(result.message);
            }

        } catch (error) {
            alert("API connection failed");
        }

        setLoading(false);
    };

    const headings = [
        {
            title: "Smarter Selling Starts with HRIAS",
            subtitle: "Turn your sales process into an AI-powered engine that finds and nurtures your next customers. Close more deals in less time with 90% verified, ready-to-convert leads across any industry."
        },
        {
            title: "Get Hot Leads, Not Just Data",
            subtitle: "Receive pre-qualified hot and cold leads backed by real-time interest signals and chat proof. Reach decision-makers directly with verified emails, numbers, and LinkedIn profiles."
        },
        {
            title: "Automate Your Outreach, Amplify Results",
            subtitle: "Connect instantly via WhatsApp, Email, and LinkedIn — all managed from one platform. Let automation handle follow-ups while you focus on turning replies into revenue."
        },
        {
            title: "Precision Targeting That Drives Conversions",
            subtitle: "AI pinpoints the right audience based on intent, keyword trends, and behavior. Spend less on unqualified prospects and 2x your conversion efficiency."
        },
        {
            title: "Scale Sales Without Scaling Your Team",
            subtitle: "Empower your team with data, automation, and insights that deliver measurable ROI. With HRIAS, every campaign becomes smarter, faster, and more profitable."
        }
    ];


    const [index, setIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % headings.length);
        }, 5000);

        return () => clearInterval(timer);
    }, []);

    return (
        <>
            <section
                id="contact-section-page"
                style={{
                    backgroundImage: `url(${banner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative', // Important for overlay
                    zIndex: 1,
                }}
            >
                {/* Overlay */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', // semi-transparent black
                        zIndex: 2,
                    }}
                ></div>

                <section className="container-fluid px-3 px-md-5 pt-3 pb-5" style={{ position: 'relative', zIndex: 3 }}>
                    <div className="row justify-content-center text-center">
                        <div className="col-lg-10">
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, x: 150 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: -150 }}
                                    transition={{ duration: 0.8, ease: "easeInOut" }}
                                >
                                    <h1
                                        className="fw-bold display-5 text-white animated-text"
                                        style={{ fontSize: "3.5rem" }}
                                    >
                                        {headings[index].title}
                                    </h1>

                                    <p className="fs-4 fw-medium text-white mt-3 animated-text">
                                        {headings[index].subtitle}
                                    </p>
                                </motion.div>
                            </AnimatePresence>
                        </div>

                    </div>
                </section>


            </section>
            <div className="container my-5">
                <div className="lead-form-container p-4 rounded position-relative">
                    <h1 className="custom-heading fw-bold mt-2">
                        Get in <span>Touch</span>!
                    </h1>
                    <p className="position-absolute top-0 end-0 mt-2 me-3" style={{ fontSize: '0.85rem', color: '#ec4899', fontWeight: 'bold' }}>
                        * marked are mandatory fields
                    </p>

                    <form onSubmit={handleSubmit}>
                        <div className="row">

                            {/* Full Name */}
                            <div className="col-md-6 mb-3">
                                <input type="text"
                                    name="fullName"
                                    className="form-control"
                                    placeholder="Full Name *"
                                    value={formData.fullName}
                                    onChange={handleChange}
                                    required />
                            </div>

                            {/* Email */}
                            <div className="col-md-6 mb-3">
                                <input type="email"
                                    name="email"
                                    className="form-control"
                                    placeholder="Email *"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required />
                            </div>

                            {/* Phone */}
                            <div className="col-md-6 mb-3">
                                <PhoneInput
                                    country={'in'}
                                    value={formData.phone}
                                    onChange={handlePhoneChange}
                                    inputClass="w-100"
                                    inputStyle={{ height: '38px' }}
                                    placeholder="Phone Number *"
                                    required />
                            </div>

                            {/* WhatsApp */}
                            <div className="col-md-6 mb-3">
                                <input type="text"
                                    name="whatsapp"
                                    className="form-control"
                                    placeholder="WhatsApp Number "
                                    value={formData.whatsapp}
                                    onChange={handleChange} />
                            </div>

                            {/* City */}
                            <div className="col-md-6 mb-3">
                                <input type="text"
                                    name="city"
                                    className="form-control"
                                    placeholder="City / Region / Location *"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required />
                            </div>

                            {/* Company */}
                            <div className="col-md-6 mb-3">
                                <input type="text"
                                    name="company"
                                    className="form-control"
                                    placeholder="Company Name *"
                                    value={formData.company}
                                    onChange={handleChange}
                                    required />
                            </div>

                            {/* Website URL */}
                            <div className="col-12 mb-3">
                                <input
                                    type="text"
                                    name="website"
                                    className="form-control"
                                    placeholder="Website URL (https:// or www)"
                                    value={formData.website}
                                    onChange={handleChange}
                                    pattern="(https?:\/\/.*)|(www\..*)"
                                    title="Please enter a valid URL starting with https://, http://, or www."
                                />
                            </div>

                            {/* Extra Notes */}
                            <div className="col-12 mb-4">
                                <textarea
                                    name="extra"
                                    className="form-control"
                                    rows="4"
                                    placeholder="Is there anything else you’d like to share? This will help us prepare better for our conversation."
                                    value={formData.extra}
                                    onChange={handleChange}
                                ></textarea>
                            </div>

                            {/* Submit */}
                            <div className="col-12 text-center">
                                <button type="submit" className="btn submit-btn px-5 py-2 fw-bold" disabled={loading}>
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </div>

                        </div>
                    </form>
                </div>
            </div></>
    );
}

export default ContactUsHrias;
